'use client'

import { configs } from '@/constants'
import { useLoader, useMounted } from '@/hooks'
import { AuthService } from '@/services'
import { supabaseAuth } from '@/services/supabase'
import { cookie } from '@/utils/storage'

export function BootstrapObserver() {
  // __STATE's
  const loader = useLoader()

  // __EFFECT's
  useMounted(() => {
    supabaseAuth.onAuthStateChange((event, session) => {
      if (['INITIAL_SESSION', 'SIGNED_IN', 'TOKEN_REFRESHED'].indexOf(event) > -1 && session) {
        console.log(`Auth chnage event:`, event)
        console.log(`Auth session:`, session)

        cookie.set(configs.APP_AUTH_ACCESS, session.access_token)
        cookie.set(configs.APP_AUTH_REFRESH, session.refresh_token)

        AuthService.profile()
      }
    })

    const element = document.querySelector('.ui--app-container')
    if (element) {
      setTimeout(() => {
        element.classList.add('ready')
        loader.off()
      }, 1e3)
    }
  })

  // __RENDER
  return null
}
